const apiModule = process.env.VUE_APP_API;
const prefix = `${apiModule}/login`;

export default ({ request }) => ({
  // 登录
  login(data) {
    return request({
      url: `${prefix}`,
      method: 'post',
      data
    })
  },
})